import styled from "styled-components";
import {flexGrowItem} from "../../../../themes/architecture/css-helpers/flex";

export const FilterCategoriesListBox = styled.div`
    ${flexGrowItem};
    flex-basis: 1%;  /* We need it so this area will not take all the places(including the sticky buttons) */
    overflow-y: auto;
`;